var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkBrokenOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    },
    d: "m 6.825,10.71 -1.06,1.065 c -0.4690213,0.470209 -1.1058637,0.734469 -1.77,0.734469 -0.6641363,0 -1.3009787,-0.26426 -1.77,-0.734469 v 0 C 1.7547915,11.305979 1.4905311,10.669136 1.4905311,10.005 1.4905311,9.3408637 1.7547915,8.7040213 2.225,8.235 L 4.35,6.115 c 0.9762496,-0.9759549 2.5587504,-0.9759549 3.535,0 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    },
    d: "m 7.175,3.29 1.06,-1.065 c 0.4690213,-0.4702085 1.1058637,-0.7344689 1.77,-0.7344689 0.664136,0 1.300979,0.2642604 1.77,0.7344689 v 0 c 0.470209,0.4690213 0.734469,1.1058637 0.734469,1.77 0,0.6641363 -0.26426,1.3009787 -0.734469,1.77 L 9.65,7.885 c -0.9762496,0.9759548 -2.5587504,0.9759548 -3.535,0 v 0"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    },
    y2: 2.7550001,
    x2: 2.7550001,
    y1: 3.8199999,
    x1: 3.8199999
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    },
    y2: 5,
    x2: 1,
    y1: 5,
    x1: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    },
    y2: 1,
    x2: 5,
    y1: 2.5,
    x1: 5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    },
    y2: 11.245,
    x2: 11.245,
    y1: 10.18,
    x1: 10.18
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    },
    y2: 9,
    x2: 13,
    y1: 9,
    x1: 11.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round"
    },
    y2: 13,
    x2: 9,
    y1: 11.5,
    x1: 9
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBrokenOutline);
export default __webpack_public_path__ + "static/media/link-broken-outline.7a2d5fd2.svg";
export { ForwardRef as ReactComponent };